exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adStatusLabel__statusLabel___j8Ixh {\n  position: absolute;\n  color: #ffffff;\n  line-height: initial;\n  left: 15px;\n  top: 15px;\n  z-index: 2;\n  min-width: 71px;\n  min-height: 20px;\n  text-align: center;\n  font-size: 12px;\n  padding: 5.5px 9px;\n  text-transform: uppercase;\n  border-radius: 2px; }\n\n.adStatusLabel__statusLabel___j8Ixh {\n  font-size: 10px;\n  padding: 3px;\n  bottom: 4px;\n  left: 4px;\n  position: absolute;\n  top: auto;\n  border-radius: 4px;\n  min-width: auto;\n  font-weight: 600;\n  text-transform: capitalize; }\n\n.adStatusLabel__activeLabel___3dsw_ {\n  background-color: #16c7a5; }\n\n.adStatusLabel__pausedLabel___1Uo2q {\n  background-color: #FFFFFF;\n  color: #828282; }\n\n.adStatusLabel__soldLabel___27VEr {\n  background-color: #a79265; }\n\n.adStatusLabel__expiredLabel___1Kq6v {\n  background-color: #f94144;\n  color: #fff; }\n\n.adStatusLabel__pendingLabel___2mYV8 {\n  background-color: #828282;\n  color: #fff; }\n\n.adStatusLabel__deleted___2etVO {\n  background-color: #3f3f3f;\n  color: #fff; }\n", ""]);

// exports
exports.locals = {
	"statusLabel": "adStatusLabel__statusLabel___j8Ixh",
	"activeLabel": "adStatusLabel__activeLabel___3dsw_",
	"pausedLabel": "adStatusLabel__pausedLabel___1Uo2q",
	"soldLabel": "adStatusLabel__soldLabel___27VEr",
	"expiredLabel": "adStatusLabel__expiredLabel___1Kq6v",
	"pendingLabel": "adStatusLabel__pendingLabel___2mYV8",
	"deleted": "adStatusLabel__deleted___2etVO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/ChatsPage/SingleChat/AdStatusLabel/adStatusLabel.scss
// module id = 5016
// module chunks = 6